import PropTypes from 'prop-types'

import { Box, Text } from '@redriverpress/system'

import locMap from '../LocMap'
import { useStudentOnboardingContext } from '../../context/onboardingStudentContext'

export default function Loc({ fontSize, color, fontWeight, copy, ...props }) {
  const [{ locale }] = useStudentOnboardingContext()

  return (
    <Box {...props}>
      <Text fontSize={fontSize} color={color} fontWeight={fontWeight}>
        {locMap[locale][copy]}
      </Text>
    </Box>
  )
}

Loc.defaultProps = {
  fontSize: 1,
  color: 'gray700',
  fontWeight: '600',
}

Loc.propTypes = {
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  color: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  copy: PropTypes.oneOf([...Object.keys(locMap.french)]).isRequired,
}
